import React, { useState, useEffect } from "react";
import "./EqMessageListItem.scss";
import { Row, Col, Checkbox } from "antd";

import { getDefaultImage, imageType } from "../../../shared/Common";
import { Avatar } from "antd-v5";
import { useAuthState } from "../../../context/Context";
import moment from "moment";
import EqTags from "../../../custom/eqTags/EqTags";

export interface IEqMessageListItem {
  message: any;
  showMessage: (value: any) => void;
  deleteMessage: (value: any) => void;
}

const EqMessageListItem = ({
  message,
  showMessage,
  deleteMessage,
}: IEqMessageListItem) => {
  const userDetails: any = useAuthState();

  const [messageView, setMessageView] = useState() as any;

  // const [check, setCheck] = useState(selected);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // setCheck(selected);
    if (message) {
      // check if sender or receiver
      setupMessage(message);
    }
  }, [message]);

  const setupMessage = (message: any) => {
    let displayMessage = { ...message };
    displayMessage.isSender = false;
    displayMessage.isRead = true;

    // check isSender
    if (displayMessage.sender) {
      if (userDetails.key === message.sender.key) {
        displayMessage.isSender = true;
      } else {
        displayMessage.isSender = false;
      }
    }

    // check is read for recipient
    if (!displayMessage.isSender) {
      const msgRecipient = displayMessage.messageRecipients.find(
        (res: any) => res.recipient?.key === userDetails.key
      );
      displayMessage.isRead = msgRecipient.isRead;
    }

    setMessageView(displayMessage);
  };

  return (
    <div className="eq-message-list-item">
      <div className="eq-message-container">
        {messageView && (
          <>
            <Row
              className={
                messageView.isRead == true
                  ? "eq-message-read"
                  : "eq-message-unread"
              }
              id="message-container"
              onClick={() => showMessage(message)}
            >
              <Col span={4}>
                <Avatar
                  size={30}
                  src={
                    messageView.sender
                      ? messageView.sender.userImage?.url
                      : getDefaultImage(imageType.trainer)
                  }
                />
              </Col>
              <Col span={20}>
                <Row justify="space-between">
                  <Col
                    // span={19}
                    className="eq-message-item eq-message-item-action"
                  >
                    {/* {"get name"} */}
                    {messageView.sender?.firstName}
                  </Col>
                  <Col
                    // span={5}
                    onClick={(e:any)=>e.stopPropagation()}
                    className="eq-message-item eq-message-item-action"
                  >
                    <EqTags
                    
                      borderColor
                      text={message.messageType === 1 ? "private" : "Group"}
                    ></EqTags>
                  </Col>
                </Row>
                <Row className="eq-message-item eq-message-item-action">
                  {messageView.subject}
                </Row>
                <Row className="eq-message-item eq-message-item-action">
                  {messageView.message}
                </Row>
                <Row justify="space-between">
                  <Col>
                    {/* {messageView.createOn.toLocaleString()} */}
                    {moment(messageView.createdOn).format("DD/MM/YYYY hh:mm A")}
                  </Col>
                  <Col
                    id="mActions"
                    className="eq-message-item eq-message-item-action"
                  >
                    <Row className="eq-message-action">
                      {/* {message.type == EqMessageType[EqMessageType.Message] && (
                        <Col
                          className="eq-message-action-reply"
                          onClick={replyClicked}
                        >
                          <span>
                            <img alt="" src="/reply.svg" />
                          </span>
                        </Col>
                      )} */}
                      {messageView.isSender && (
                        <Col
                          className="eq-message-action-delete"
                          onClick={(e: any) => {
                            e.stopPropagation();
                            deleteMessage(message);
                          }}
                        >
                          <span className="">
                            <img alt="" src="/trash-alt-red.svg" />
                          </span>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};

export default EqMessageListItem;
